module.exports = __webpack_public_path__ + "static/media/reswalk.3662db13.jpg";